import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { usePhoneNumber } from '../hooks/usePhoneNumber';
import logo from '../image/logo/barcelona cab logo.png';

const Footer = () => {
    const { t } = useTranslation();
    const { phoneNumber } = usePhoneNumber();

    return (
        <footer className="bg-slate-900 text-white pt-24 pb-12 border-t border-slate-800 font-montserrat">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
                    {/* Brand & Description */}
                    <div className="md:col-span-1">
                        <div className="flex items-center gap-3 mb-6">
                            <div className="p-2 bg-white rounded-xl">
                                <img src={logo} alt="Barcelona Cab Logo" className="w-12 h-12 object-contain" />
                            </div>
                            <span className="text-xl font-black tracking-tighter">MY<span className="text-blue-500">TAXI</span>BCN</span>
                        </div>
                        <p className="text-slate-400 text-sm leading-relaxed font-medium">
                            {t('footer.description') || "Premium transportation services across Barcelona. Available 24/7 for all your airport transfer and local travel needs."}
                        </p>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h3 className="text-xs font-black uppercase tracking-[0.2em] text-blue-500 mb-6">{t('footer.links_title') || "Quick Links"}</h3>
                        <ul className="space-y-4">
                            <li>
                                <Link to="/" className="text-slate-400 hover:text-white transition-all text-sm font-bold uppercase tracking-widest">
                                    {t('navbar.home')}
                                </Link>
                            </li>
                            <li>
                                <Link to="/explore" className="text-slate-400 hover:text-white transition-all text-sm font-bold uppercase tracking-widest">
                                    {t('navbar.explore')}
                                </Link>
                            </li>
                            <li>
                                <Link to="/about" className="text-slate-400 hover:text-white transition-all text-sm font-bold uppercase tracking-widest">
                                    {t('navbar.about')}
                                </Link>
                            </li>
                            <li>
                                <Link to="/admin" className="text-slate-400 hover:text-white transition-all text-sm font-bold uppercase tracking-widest">
                                    Admin
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h3 className="text-xs font-black uppercase tracking-[0.2em] text-blue-500 mb-6">{t('footer.contact')}</h3>
                        <ul className="space-y-4 text-sm font-bold">
                            <li className="flex flex-col gap-1">
                                <span className="text-[10px] text-slate-500 uppercase tracking-widest">Location</span>
                                <span className="text-slate-300">Barcelona, Spain</span>
                            </li>
                            <li className="flex flex-col gap-1">
                                <span className="text-[10px] text-slate-500 uppercase tracking-widest">Phone</span>
                                <a href={`tel:${phoneNumber}`} className="text-slate-300 hover:text-blue-400 transition-colors">{phoneNumber}</a>
                            </li>
                            <li className="flex flex-col gap-1">
                                <span className="text-[10px] text-slate-500 uppercase tracking-widest">Email</span>
                                <a href="mailto:bcntaxi247@gmail.com" className="text-slate-300 hover:text-blue-400 transition-colors">bcntaxi247@gmail.com</a>
                            </li>
                        </ul>
                    </div>

                    {/* Legal or Extra */}
                    <div>
                        <h3 className="text-xs font-black uppercase tracking-[0.2em] text-blue-500 mb-6">{t('footer.legal') || "Legal"}</h3>
                        <ul className="space-y-4">
                            <li><button className="text-slate-400 hover:text-white transition-all text-sm font-bold uppercase tracking-widest">Privacy Policy</button></li>
                            <li><button className="text-slate-400 hover:text-white transition-all text-sm font-bold uppercase tracking-widest">Terms of Service</button></li>
                            <li><button className="text-slate-400 hover:text-white transition-all text-sm font-bold uppercase tracking-widest">Cookies</button></li>
                        </ul>
                    </div>
                </div>

                <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-[10px] font-black uppercase tracking-[0.15em] text-slate-500">
                    <p>&copy; {new Date().getFullYear()} MY TAXI BCN. {t('footer.rights')}.</p>
                    <div className="flex gap-6">
                        <span>Developed with ❤️ in BCN</span>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
